import { useQuery } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const QUERY = graphql(`
  query newsBanners($companyId: ID!) {
    newsBanners(companyId: $companyId) {
      ...NewsBannerItem
    }
  }
`);

export function useNewsBanners(companyId: string) {
  return useQuery(QUERY, {
    variables: {
      companyId,
    },
  });
}
